import React, { useState, useEffect, useCallback } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import BeforeAfter2 from "../Assets/results/buitrago_result.jpeg";
import BeforeAfter3 from "../Assets/results/resultado_atleta3.jpeg";
import BeforeAfter4 from "../Assets/results/resultado_fem.jpeg";
import BeforeAfter5 from "../Assets/results/kayo_resultado.jpeg";
import "./Results.css";

const Results = () => {
  const resultsData = [
    { image: BeforeAfter2, hashtag: "#TeamSaboia" },
    { image: BeforeAfter3, hashtag: "#TeamSaboia" },
    { image: BeforeAfter4, hashtag: "#TeamSaboia" },
    { image: BeforeAfter5, hashtag: "#TeamSaboia" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev === resultsData.length - 1 ? 0 : prev + 1));
  }, [resultsData.length]);

  const prevSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev === 0 ? resultsData.length - 1 : prev - 1));
  }, [resultsData.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  const handleCtaClick = () => {
    const message = encodeURIComponent(
      "Olá! Quero ser o próximo resultado de sucesso do Team Saboia!"
    );
    window.open(`https://wa.me/5561995909917?text=${message}`, "_blank");
  };

  return (
    <section className="results" id="results" data-animate="fade-up" data-delay="200">

      <div className="results-header">
        <h1 className="results-title">Resultados Reais</h1>
        <p className="results-subtitle">Do iniciante ao atleta de alta performance</p>
      </div>

      <div className="results-carousel">
        <button className="results-arrow" onClick={prevSlide} aria-label="Resultado anterior">
          <FiChevronLeft />
        </button>

        <div className="results-slide">
          <img
            className="results-image"
            src={resultsData[currentIndex].image}
            alt="Resultado de aluno Team Saboia"
          />
          <p className="results-hashtag">{resultsData[currentIndex].hashtag}</p>
        </div>

        <button className="results-arrow" onClick={nextSlide} aria-label="Próximo resultado">
          <FiChevronRight />
        </button>
      </div>

      <div className="results-dots">
        {resultsData.map((_, index) => (
          <span
            key={index}
            className={`results-dot ${index === currentIndex ? "results-dot--active" : ""}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Ir para resultado ${index + 1}`}
          />
        ))}
      </div>

      <div className="results-cta-wrapper">
        <button className="results-cta" onClick={handleCtaClick}>
          Quero ser o próximo
        </button>
      </div>

    </section>
  );
};

export default Results;